import { entityReport } from '@api/api/entity-report';
import { SnakeMeta } from '@api/api/timeseries-schema';
import { parseEntityScreenerData } from '@terminal/hooks/use-one-day-return-live-price/utils';
import { postEntity } from '@terminal/services/entities/entity-service';
import { fetchSnakeMeta } from '@terminal/services/overview-widget/overview-widget-service';
import { apiFetch } from '@terminal/utils/api-fetch/apiFetch';
import { fetchFilteredEntities } from '@terminal/widgets/scenario/hooks/use-screener-entities-tags/entity-screener-service/entity-screener-service';
import { mapEntityTagsToDefaultOptions } from '@terminal/widgets/scenario/hooks/use-screener-entities-tags/useScreenerEntitiesTags';

export const getEntityValues = async (tag: string) => {
  const [entity, latestValues, entityScreener] = await Promise.all([
    postEntity(tag),
    apiFetch(entityReport.getEntityLatestValues.path(tag), {
      schema: entityReport.getEntityLatestValues.schema,
    }),
    fetchFilteredEntities(mapEntityTagsToDefaultOptions([tag])),
  ]);

  if (
    entity.error ||
    !entity?.data ||
    !latestValues?.data ||
    !entityScreener?.data
  ) {
    return undefined;
  }

  const snakeMeta: SnakeMeta | undefined = await (async () => {
    try {
      return await fetchSnakeMeta(entity.data.default_snake);
    } catch {
      return undefined;
    }
  })();

  const { liveReturn1D } = parseEntityScreenerData(entityScreener);

  return {
    entity: entity.data,
    latestValues: latestValues?.error ? {} : latestValues?.data,
    snakeMeta,
    liveReturn1D: liveReturn1D?.value,
  };
};
